<section #carouselListDiv>
    <div class="listing-container product-layout-container">
        <div class="side-banner-container">
            @if (sectionDetails()[selectedIndex()]; as sectionDetail) {
            <img (click)="navigateToCorrespondingPage(sectionDetail)" class="side-banner-image" [src]="
            sectionDetail.image ||
            'https://www.hiphopshakespeare.com/wp-content/uploads/2013/11/dummy-image-portrait.jpg'
          " alt="side-banner" />
            }
        </div>

        <div class="product-list-container">
            @if (
            sectionConfiguration() &&
            sectionConfiguration().title &&
            ((!isMobile() && sectionConfiguration().show_title_in_desktop) ||
            (isMobile() && sectionConfiguration().show_title_in_mobile))
            ) {
            <h1 class="product-list-title">
                {{ sectionConfiguration().title }}
            </h1>
            }

            @if (sectionDetails().length) {
            @if (sectionDetails().length > 1) {
            <ul class="collection-label-appearance">
                @for (sectionDetail of sectionDetails(); track sectionDetail.id; let i = $index) {
                <li (click)="changeSelectedIndex(i)" [class.disabled]="loader()">
                    <span [class.group-item-active]="selectedIndex() === i" class="collection-label-item">
                        {{ sectionDetail.name }}
                    </span>
                </li>
                }
            </ul>
            }
            } @else {
            <div class="spacer"></div>
            }

            <!-- empty state -->
            @if (!loader() && !currentProducts().length) {
            <div class="empty-state-wrapper">
                <h1>No Products Available</h1>
            </div>
            }

            @if (currentProducts().length > 0) {
            <owl-carousel-o class="carousel-container product-list" #sideBannerCarouselList [options]="customOptions()" [ngClass]="{
            'countdown-carousel': countDownTemplate() && countDownPresent(),
          }">
                @for (product of currentProducts(); track product.id; let i = $index) {
                <ng-template carouselSlide>
                    <webstore-dynamic-home-product-card [showCountdown]="countDownTemplate() && !!product?.deal" [showCashpoint]="showCashpoint()" [showPercentageDiscount]="showPercentageDiscount()" [showAddToCart]="showAddToCart()" [baseHtml]="baseHtml()" [productInput]="product" (addToCartClicked$)="addToCartClicked$.emit($event)" (productClicked$)="productClicked$.emit(product.url_path)">
                    </webstore-dynamic-home-product-card>
                </ng-template>
                }
            </owl-carousel-o>
            }

            <div [hidden]="loader() || !currentProducts().length" [innerHTML]="carouselListNavigationSection() | safeHtml"></div>
            @if (loader()) {
            <webstore-card-loader></webstore-card-loader>
            }
        </div>
    </div>
</section>